import React, { forwardRef } from 'react';
import clsx from 'clsx';

export const PopoverButton = forwardRef((props, ref) => {
  const { className, ...restProps } = props;
  return (
    <button
      ref={ref}
      className={clsx(className, 'button--popover', 'button--unstyled')}
      {...restProps}
    />
  );
});